export default "__VITE_PUBLIC_ASSET__58802b81__"